import { apiBuilder, prefixApi } from "@zodios/core";
import { z } from "zod";
import { orgSchema } from "../../common/orgSchema";

export const organizationsApiDefinitions = prefixApi(
  "/api",
  apiBuilder({
    alias: "getOrganizationMarketplaces",
    method: "get",
    path: "/organizations/:orgId/marketplaces",
    status: 200,
    response: z.object({
      default_marketplace: z.string(),
      markets: z.record(
        z.string(),
        z.object({ product_count: z.number().optional(), ad_count: z.number().optional() }),
      ),
    }),
  })
    .addEndpoint({
      alias: "getOrganizations",
      method: "get",
      path: "/organizations",
      parameters: [
        {
          name: "org_type",
          type: "Query",
          schema: z.string().optional(),
        },
        {
          name: "primary_only",
          type: "Query",
          schema: z.boolean().optional(),
        },
        {
          // Staff only: include hidden organizations.
          name: "all_orgs",
          type: "Query",
          schema: z.boolean().optional(),
        },
        {
          // Each org's `mcp_token` is null unless asked for: minting one per org is costly.
          name: "include_mcp_token",
          type: "Query",
          schema: z.boolean().optional(),
        },
      ],
      status: 200,
      response: z.array(orgSchema),
    })
    .addEndpoint({
      alias: "searchOrganizations",
      method: "get",
      path: "/org_search/",
      parameters: [
        {
          name: "profile_name",
          type: "Query",
          schema: z.string().optional(),
        },
        {
          name: "asin",
          type: "Query",
          schema: z.string().optional(),
        },
        {
          name: "seller_id",
          type: "Query",
          schema: z.string().optional(),
        },
      ],
      status: 200,
      response: z.object({ orgs: z.array(orgSchema) }),
    })
    .addEndpoint({
      alias: "putOrgId",
      method: "put",
      path: "/organizations/",
      parameters: [{ name: "body", type: "Body", schema: z.object({ id: z.number() }) }],
      status: 200,
      response: z.unknown(),
    })
    .addEndpoint({
      alias: "listStaffOrganizations",
      method: "get",
      path: "/manage/organizations/",
      parameters: [
        { name: "limit", type: "Query", schema: z.number().optional() },
        { name: "page", type: "Query", schema: z.number().optional() },
        { name: "search", type: "Query", schema: z.string().optional() },
      ],
      status: 200,
      response: z.object({
        count: z.number(),
        next: z.string().nullable(),
        previous: z.string().nullable(),
        results: z.array(orgSchema),
      }),
    })
    .build(),
);
